import React from 'react';
import backgroundImage from '../../assets/basketball-bg.jpg';

const MobileHero: React.FC = () => {
  return (
    <div 
      className="mobile-hero" 
      style={{ 
        backgroundImage: `url(${backgroundImage})` 
      }}
    >
      <div className="mobile-hero-content">
        <h1 className="mobile-title scroll-animate">BASKETBALL CULTURE</h1>
        <p className="mobile-subtitle scroll-animate">THE PODCAST THAT INSPIRES CHANGE</p>
      </div>
    </div>
  );
};

export default MobileHero; 